import { render, staticRenderFns } from "./VaCard.vue?vue&type=template&id=72215f10&"
import script from "./VaCard.vue?vue&type=script&lang=js&"
export * from "./VaCard.vue?vue&type=script&lang=js&"
import style0 from "./VaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports